import 'core-js';

import scrollDir from 'scrolldir';
import { applyNowButton, printTime, skipToMain } from './modules/helpers';
import LumcNews from './modules/lumcnews';
import { themeSwitch } from './modules/header';
import { locations } from './modules/locations';
import {
    stickyFilters,
    polyclinicsObserver,
    centrumHeaderObserver,
} from './modules/intersection-observer';
import { squareImageHeader } from './modules/square-image-header';

import { cookieModal, siteNavOverlay } from './modules/modal';
import { alphabetScroll } from './modules/polyclinics';
import { instances } from './modules/dropdown-instances';
import { jobApplicationForm } from './modules/job-application-form';
import { centrumHeader } from './modules/centrum-header.js';

import { faqLoad } from './modules/faq-load';
import { carouselInstances } from './modules/carousel-instances';
import { siteSearch } from './modules/sitesearch';
import { jobVacanciesSearch } from './modules/jobvacancies-search';
import { jobVacanciesSync } from './modules/jobvacancies-sync';
import { tableModal } from './modules/table-modal';
import { diseasesAndConditionsSearch } from './modules/disease-and-conditions-search';
import { clinicsWardsCentersSearch } from './modules/clinics-wards-centers-search';
import { goToTop } from './modules/go-to-top';
import { tocScroll } from './modules/toc-scroll';
import { tocHelper } from './modules/toc-helper';
import { profileEdit } from './modules/profile-edit';
import { jobAlert } from './modules/jobalert';
import { dataLayerEvents } from './modules/datalayer-events';

Number.isNaN =
    Number.isNaN ||
    function isNaN(input) {
        // eslint-disable-next-line no-self-compare
        return typeof input === 'number' && input !== input;
    };

// eslint-disable-next-line no-extend-native
String.prototype.endsWith =
    ''.endsWith ||
    // eslint-disable-next-line func-names
    function (s) {
        return !this.split(s).pop();
    };

if (!window.Promise) {
    window.Promise = Promise;
}

document.addEventListener('DOMContentLoaded', () => {
    // pageAnimation();
    scrollDir({ dir: 'up' });
    themeSwitch();
    // loginSubMenu();
    siteNavOverlay();
    squareImageHeader();
    locations();
    stickyFilters();
    applyNowButton();
    cookieModal();
    alphabetScroll();
    polyclinicsObserver();
    centrumHeaderObserver();
    instances();
    jobApplicationForm();
    centrumHeader();
    printTime();
    // eslint-disable-next-line no-new
    new LumcNews();
    faqLoad();
    skipToMain();
    carouselInstances();
    siteSearch();
    jobVacanciesSearch();
    jobVacanciesSync();
    diseasesAndConditionsSearch();
    clinicsWardsCentersSearch();
    goToTop();
    tocScroll();
    tocHelper();
    profileEdit();
    tableModal('.js-table-modal__open', '.js-table-modal__close');
    jobAlert();
    dataLayerEvents();
});
